export const REACT_APP_ENV = '{Environment}';
export const CHF = 'CHF';
export const USDT = 'USDT';
export const USD = 'USD';
export const MAIN_CURRENCY = USDT;
export const COMPANY_NAME = 'd3c';
export const COMPANY_DOMAIN = 'https://d3c.io';
export const COMPANY_DOMAIN_SHORT = 'd3c.io';
export const COMPANY_SUPPORT_EMAIL = 'hello@d3c.io';